import HeaderContent from "component/layout/HeaderContent";
import React from "react";
import TopHeader from "./component/TopHeader";
import HomePage from './HomePage';

export default function HomePageRouter() {
  return (
    <HeaderContent>
      <TopHeader />

      <HomePage />
    </HeaderContent>
  );
}
